let okeResponse = require('okeoke.standardresponse')

export default function itemDiscountsProcessor(order, catalog, client) {
  function autoApplyItemDiscounts() {
    let discounts = Object.values(catalog?.discounts || {})
    for (let discount of discounts) {
      if (discount.autoApply) {
        if(discount.locations?.length > 0 && !discount.locations.includes(order.order.locationUUID)) continue
        setDiscountItems(discount.id, null, true)
      }
    }
  }

  function checkItemDiscount(orderItemUUID, orderObj = null) {
    if (orderObj) {
      for (let discount of orderObj.itemDiscounts || []) {
        if (discount?.orderItemUUID === orderItemUUID) return discount
      }
    } else {
      for (let discount of order.order?.itemDiscounts || []) {
        if (discount?.orderItemUUID === orderItemUUID) return discount
      }
    }
    return null
  }

  function updateItemDiscount(orderItemUUID, skipValid = false, overridePaid = false) {
    let existingDiscount = checkItemDiscount(orderItemUUID)
    if (existingDiscount != null && existingDiscount?.count > 0) {
      let orderItem = order.assembledOrderItems[orderItemUUID]
      let unitPrice = (existingDiscount?.excludeModifiers ? orderItem.price : orderItem.sumPriceUnit)
      if (existingDiscount?.count !== orderItem?.count || existingDiscount?.unitPrice !== unitPrice) {
        setItemDiscount(orderItemUUID, existingDiscount.discountID, null, skipValid, overridePaid)
      }
    }
  }

  function setItemDiscount(orderItemUUID, discountID, count, skipValid = false, overridePaid = false, autoApplied = false, remainingAmount = 0) { // User for role permission later...
    // Get item
    let itemUUID = order.assembledOrderItems[orderItemUUID]?.itemUUID
    let orderItem = order.items.assembleItem(itemUUID, orderItemUUID)
    if (orderItem == null) return okeResponse(false, 404, 'Item not found.', { errMsgCode: 'order.item.notfound' })
    // If order item paid, cannot change discount
    if (!overridePaid && (orderItem.payment?.amount > 0 || order?.order?.paymentsNeeded <= 2)) {
      return okeResponse(false, 401, 'Item already paid.', { errMsgCode: 'order.item.discount.error.paid' })
    }
    let assembled = catalog.getDiscount(discountID)
    if (assembled == null) return okeResponse(false, 404, 'Discount not found.', { errMsgCode: 'order.item.discount.notfound' })
    // Check if discount is valid
    if (!skipValid && !assembled.valid) return okeResponse(false, 401, 'Invalid discount.', { errMsgCode: 'order.item.discount.invalid' })
    // Check if discount is applicable and update
    let itemDiscount = checkItemDiscount(orderItemUUID)
    if (itemDiscount != null && itemDiscount.discountID === discountID && count === 0) {
      if (itemDiscount.count > 0) {
        order.addUpdate({
          itemDiscounts: {
            [orderItemUUID]: {
              orderItemUUID,
              discountID
            }
          }
        })
        return okeResponse(true, 200, 'Discount unset.', { errMsgCode: 'order.item.discount.unset' })
      } else {
        return okeResponse(false, 401, 'Discount already unset.', { errMsgCode: 'order.item.discount.unset.alreadyunset' })
      }

    } else {
      if (count === 0) return okeResponse(false, 401, 'Invalid count.', { errMsgCode: 'order.item.discount.invalid.count' })
      if (itemDiscount != null && itemDiscount.discountID !== discountID && +itemDiscount.count > 0) return okeResponse(false, 401, 'Discount not applicable. Remove existing first.', { errMsgCode: 'order.item.discount.notapplicable.remove.exsiting' })
      if (itemDiscount != null && itemDiscount.discountID === discountID && itemDiscount.count === orderItem.count && autoApplied && count == null) return okeResponse(false, 401, 'Discount already applied.', { errMsgCode: 'order.item.discount.alreadyapplied' })
      if (assembled?.excludeSizes?.[orderItem.selectedSizeUUID] == null && (assembled?.includeSizes == null || assembled?.includeSizes?.[orderItem.selectedSizeUUID] != null)) {
        let unitPrice = (assembled?.excludeModifiers ? orderItem.price : orderItem.sumPriceUnit)
        let unitDiscount = 0
        let packageDiscount = 0
        if(+assembled?.discountPercent !== 0) {
          unitDiscount = Math.round(unitPrice * (assembled.discountPercent / 100))
          packageDiscount = (assembled?.includePackaging ? Math.round((orderItem.packagePrice || 0) * (assembled.discountPercent / 100)) : 0)
        } else {
          if(remainingAmount > 0) {
            //console.log(unitPrice, orderItem.count, remainingAmount)
            let multipliedAmount = unitPrice * orderItem.count
            //console.log('multipliedAmount', multipliedAmount)
            let fullDiscount = Math.min(multipliedAmount, remainingAmount)
            unitDiscount = fullDiscount / orderItem.count
            //console.log('fullDiscount', fullDiscount)
            remainingAmount -= fullDiscount
            if(remainingAmount > 0) {
              let multipliedAmount = Math.round((orderItem.packagePrice || 0) * orderItem.count)
              let fullDiscount = (assembled?.includePackaging ? Math.min(multipliedAmount, remainingAmount) : 0)
              packageDiscount = fullDiscount / orderItem.count
              remainingAmount -= fullDiscount
            }
          }
        }
        order.addUpdate({
          itemDiscounts: {
            [orderItemUUID]: {
              orderItemUUID,
              name: assembled.name,
              discountID,
              excludeModifiers: assembled.excludeModifiers,
              includePackaging: assembled.includePackaging,
              unitPrice,
              unitDiscount,
              packageDiscount,
              count: orderItem.count,
              sysUserUUID: client.localUser?.userUUID || null,
              insertTimestamp: new Date().getTime()
            }
          }
        })
        return okeResponse(true, 200, 'Discount set.', { errMsgCode: 'order.item.discount.set', remainingAmount })
      }
    }
    return okeResponse(false, 401, 'Discount not applicable.', { errMsgCode: 'order.item.discount.notapplicable' })
  }

  function unsetItemDiscount(orderItemUUID) {
    let existingDiscount = checkItemDiscount(orderItemUUID)
    if (existingDiscount != null) {
      return setItemDiscount(orderItemUUID, existingDiscount.discountID, 0, true)
    }
    return okeResponse(false, 404, 'Discount not found.', { errMsgCode: 'order.item.discount.notfound' })
  }

  function calculateItemDiscounts() {
    let res = { items: {} }
    let total = 0
    for (let orderItem of Object.values(order.assembledOrderItems)) {
      let uid = orderItem.orderItemUUID
      let itemDiscount = checkItemDiscount(uid)
      if (itemDiscount == null || !itemDiscount.count) {
        continue
      }
      let calculatedDiscount = {
        name: itemDiscount.name,
        id: itemDiscount.discountID,
        amount: itemDiscount.unitDiscount * itemDiscount.count,
        packageAmount: itemDiscount.packageDiscount * itemDiscount.count
      }
      if (res.items[uid] != null) {
        if (res.items[uid].discounts != null) {
          res.items[uid].discounts.push(calculatedDiscount)
        } else {
          res.items[uid].discounts = [calculatedDiscount]
        }
      } else {
        res.items[uid] = {
          discounts: [calculatedDiscount]
        }
      }
      total += (itemDiscount.unitDiscount * itemDiscount.count) + (itemDiscount.packageDiscount * itemDiscount.count)
    }
    res.local = {
      total: (res.local?.total || 0) + total
    }
    return res
  }

  function applyItemDiscount(itemDiscount, orderObj) {
    if (itemDiscount == null) return okeResponse(false, 404, 'Discount not found.', { errMsgCode: 'order.item.discount.notid' })
    let currentItemDiscount = checkItemDiscount(itemDiscount.orderItemUUID, orderObj)
    if (currentItemDiscount != null) {
      if (JSON.stringify(currentItemDiscount) !== JSON.stringify(itemDiscount)) {
        currentItemDiscount.discountID = itemDiscount.discountID
        currentItemDiscount.excludeModifiers = itemDiscount.excludeModifiers
        currentItemDiscount.includePackaging = itemDiscount.includePackaging
        currentItemDiscount.name = itemDiscount.name
        currentItemDiscount.unitPrice = itemDiscount.unitPrice
        currentItemDiscount.unitDiscount = itemDiscount.unitDiscount
        currentItemDiscount.packageDiscount = itemDiscount.packageDiscount
        currentItemDiscount.count = itemDiscount.count
        return okeResponse(true, 201, 'Discount updated.', { errMsgCode: 'order.item.discount.updated' })
      } else {
        return okeResponse(true, 200, 'Discount already applied.', { errMsgCode: 'order.item.discount.alreadyapplied' })
      }
    } else {
      orderObj ? orderObj.itemDiscounts.push(itemDiscount) : order.order.itemDiscounts.push(itemDiscount)
      return okeResponse(true, 201, 'Discount applied.', { errMsgCode: 'order.item.discount.applied' })
    }
  }

  function unsetDiscountItems(discountID) {
    //console.log('unsetDiscountItems', discountID)
    let results = []
    for (let itemDiscount of order.order.itemDiscounts) {
      if (itemDiscount.discountID === discountID) {
        results.push(unsetItemDiscount(itemDiscount.orderItemUUID))
      }
    }
    return results
  }

  function setDiscountItems(discountID, orderItemUUIDs = null, autoApplied = false) {
    //console.log('setDiscountItems', discountID, orderItemUUIDs)
    if (orderItemUUIDs == null) {
      orderItemUUIDs = Object.keys(order.assembledOrderItems)
    }
    let results = []
    for (let orderItemUUID of orderItemUUIDs) {
      results.push(setItemDiscount(orderItemUUID, discountID, null, false, false, autoApplied))
    }
    return results
  }



  return {
    updateItemDiscount,
    setItemDiscount,
    unsetItemDiscount,
    autoApplyItemDiscounts,
    calculateItemDiscounts,
    applyItemDiscount,
    unsetDiscountItems,
    setDiscountItems
  }
}
